<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">险种分类</span>
        <Select v-model="searchParams.themeIds" placeholder="请选择" clearable multiple filterable>
          <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">费用类型</span>
        <Select v-model="searchParams.commissionStyles" clearable transfer multiple>
          <Option value="1">基础费用</Option>
          <Option value="2">团队长基础管理费</Option>
          <Option value="3">限时加费</Option>
          <Option value="4">后置费用</Option>
          <Option value="5">团队长后置管理费</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">保单年度</span>
        <Input type="number" v-model="searchParams.commissionIndex" placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">交费期次</span>
        <Input type="number" v-model="searchParams.commissionPeriods" placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">承保日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">出单人</span>
        <Input v-model="searchParams.salesmanCondition" clearable placeholder="请输入姓名或工号" />
      </div>

      <div class="btn-item">
        <Button type="primary" class="btn-reset" ghost @click="exportTable">导出</Button>
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData"></Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';

export default {
  mixins: [pageTool, common],
  data() {
    return {
      searchParams: {
        date: []
      },
      productThemeList: [],
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 220
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 150
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payDesc',
          minWidth: 150
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '实收保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用类型',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3)) {
              return <span>团队长基础管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4 || commissionType == 20) {
              return <span>限时加费</span>;
            } else if (commissionType == 5 && owerType == 3) {
              return <span>后置费用</span>;
            } else if (commissionType == 5 && owerType == 2) {
              return <span>团队长后置管理费</span>;
            }
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            let commission = params.row.commission;
            return <span>{ commission? commission+'%' : '-' }</span>
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 100
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 100
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = JSON.parse(params.row.sellType);
            if (sellType.includes('1')) {
              return <span>网销产品</span>;
            } else if (sellType.includes('3')) {
              return <span>经代产品</span>;
            }
          }
        },
        {
          title: '长短险标志',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let productType = params.row.productType;
            if (productType == 1) {
              return <span>长险</span>;
            } else {
              return <span>短险</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            if (params.row.receiptStatus == '-1') {
              return <span>无需回执</span>;
            } else if (params.row.receiptStatus == '0') {
              return <span>待回执</span>;
            } else if (params.row.receiptStatus == '1') {
              return <span>回执成功</span>;
            } else if (params.row.receiptStatus == '2') {
              return <span>回执失败</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          key: 'verifyStatus',
          align: 'center',
          minWidth: 100,
          ellipsis: true,
          tooltip: true,
          render(h, params) {
            if (params.row.verifyStatus == '0') {
              return <span>待回访</span>;
            } else if (params.row.verifyStatus == '1') {
              return <span>回访成功</span>;
            } else if (params.row.verifyStatus == '2') {
              return <span>回访失败</span>;
            } else if (params.row.verifyStatus == '3') {
              return <span>无需回访</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        },
        {
          title: '被保人',
          align: 'center',
          key: 'insuredName',
          minWidth: 100
        }
      ]
    };
  },

  created() {
    this.getProductTheme();
    this.getList();
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 承保日期
      if (data.date && data.date[0]) {
        data.insureTimeStart = data.date[0];
        data.insureTimeEnd = data.date[1];
      }
      delete data.date;
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryUserWaitWithSelf',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 1,
          ...data,
          owerTypes: [2, 3],
          feeStatus: 1, //默认参数
          settlementStatus: 0 //默认参数
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 导出
    exportTable() {
      if(!this.tableData.length) {
        this.$notice.msg("暂无可导出数据");
        return
      }
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 承保日期
      if (data.date && data.date[0]) {
        data.insureTimeStart = data.date[0];
        data.insureTimeEnd = data.date[1];
      }
      delete data.date;
      let searchParams = {
        type: 1,
        ...data,
        owerTypes: [2, 3],
        feeStatus: 1, //默认参数
        settlementStatus: 0 //默认参数
      };
      this.$units.downloadFile('/buz/commissionLog/exportUserWaitWithSelf', searchParams, 'POST');
    },

    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },

    resetSearch() {
      this.searchParams = {};
      this.searchParams.date = [];
      this.searchAjax();
    },

    // 分页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped></style>
